import React, { useEffect, useState } from "react";
import "./ContactUs2.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import logoAddress from "../../assest/About/image.png";
import { FaIdCard } from "react-icons/fa";
import axios from "axios";

const ContactUs2 = () => {
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    company: "",
    email: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const [contactPopup, setContactPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    reloadAfterClose: false,
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const subjectParam = params.get("subject");
    if (subjectParam) {
      setFormData((prevData) => ({ ...prevData, subject: subjectParam }));
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const showContactPopup = ({
    type = "info",
    title = "",
    message = "",
    reloadAfterClose = false,
  }) => {
    setContactPopup({
      show: true,
      type,
      title,
      message,
      reloadAfterClose,
    });
  };

  const closeContactPopup = () => {
    const shouldReload = contactPopup.reloadAfterClose;

    setContactPopup({
      show: false,
      type: "",
      title: "",
      message: "",
      reloadAfterClose: false,
    });

    if (shouldReload) {
      const newUrl = window.location.pathname;
      window.history.replaceState(null, "", newUrl);
      window.location.reload();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.message ||
      !formData.phoneNumber
    ) {
      showContactPopup({
        type: "error",
        title: "ส่งข้อความไม่สำเร็จ",
        message: "Please fill in all required information",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showContactPopup({
        type: "error",
        title: "อีเมลไม่ถูกต้อง",
        message: "Please enter a valid email",
      });
      return;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phoneNumber)) {
      showContactPopup({
        type: "error",
        title: "เบอร์โทรศัพท์ไม่ถูกต้อง",
        message: "Please enter a valid phone number (10 digits)",
      });
      return;
    }

    try {
      const response = await axios.post("/contactus", formData);

      setFormData({
        name: "",
        position: "",
        company: "",
        email: "",
        phoneNumber: "",
        subject: "",
        message: "",
      });

      showContactPopup({
        type: "success",
        title: "ส่งข้อความสำเร็จ",
        message: response.data.message || "Message sent successfully!",
        reloadAfterClose: true,
      });
    } catch (error) {
      console.error(error);

      showContactPopup({
        type: "error",
        title: "เกิดข้อผิดพลาด",
        message: "Error sending message",
      });
    }
  };

  return (
    <div className="contact-container">
      <div className="form-section">
        <h2 className="h2-Contact">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="position">Job Position</label>
            <input
              type="text"
              id="position"
              placeholder="Enter your Job Position"
              value={formData.position}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="company">Company Name</label>
            <input
              type="text"
              id="company"
              placeholder="Enter your Company Name"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              placeholder="Enter your phone number"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              placeholder="Enter the subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              placeholder="Enter your message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="btn-submit">
            Send
          </button>
        </form>
      </div>

      <div className="info-section">
        <h2 className="h2-Contact">Information</h2>
        <p>
          <FaMapMarkerAlt /> <strong>Registered Address :</strong>
          <br />
          9/14 Moo4, Bangkhunkong, Bangkruay, Nonthaburi, 11130, Thailand
        </p>
        <p>
          <FaIdCard /> <strong>Tax ID :</strong> 0125556009472
          <br />
        </p>
        <p>
          <FaPhoneAlt /> <strong>Phone :</strong> 02 266 6500 , 02 266 6501
        </p>
        <p>
          <FaMapMarkerAlt /> <strong>Operating Address : </strong> Proscope Co.,
          Ltd
          <br />
          23/34-35,358, The prime Office Building, Floor 5, Room A504, Tri Mit
          Rd, Talat Noi, Samphanthawong, Bangkok 10100{" "}
        </p>
        <div className="imageAContainer">
          <img src={logoAddress} className="logoAddress" alt="Logo" />
        </div>
      
        <p>
          <FaEnvelope /> <strong>Email:</strong>{" "}
          <a href="mailto:sales@proscope.co.th">sales@proscope.co.th</a>
        </p>
        <h3 className="h3-Contact">
          <FaClock /> Working Hours
        </h3>
        <p>
          Monday - Friday: 8.30am to 5:30pm
          <br />
          Saturday - Sunday: Closed
        </p>
      </div>
      {contactPopup.show && (
        <div className="contact-message-popup-overlay">
          <div className="contact-message-popup-modal">
            <div
              className={`contact-message-popup-icon ${
                contactPopup.type === "success" ? "success" : "error"
              }`}
            >
              {contactPopup.type === "success" ? "✓" : "!"}
            </div>

            <h3>{contactPopup.title}</h3>

            <p>{contactPopup.message}</p>

            <div className="contact-message-popup-actions">
              <button
                type="button"
                className={`contact-message-popup-btn ${
                  contactPopup.type === "success" ? "success" : "error"
                }`}
                onClick={closeContactPopup}
              >
                ตกลง
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs2;
